import persistState from "redux-localstorage"
import { INITIAL_STATE } from "../reducer"

/* eslint-disable multiline-ternary */
const serailizeSession = store =>
  JSON.stringify(
    store && store.session && store.session.token
      ? {
          version: store.session.version,
          token: store.session.token,
          refreshToken: store.session.refreshToken,
          tokenType: store.session.tokenType,
        }
      : {},
  )
/* eslint-enable */

function getStorageConfig() {
  return {
    key: `session`,
    serialize: serailizeSession,
    deserialize: state => ({
      session: {
        ...INITIAL_STATE,
        ...(state ? JSON.parse(state) : {}),
      },
    }),
    merge: (localState, persistenState) => persistenState,
  }
}

const enhancer = persistState(`session`, getStorageConfig())

export default enhancer
